import React from 'react';

// Esto es un High Order Component (HOC) que recibe un componente de React y un array con los
// roles que tienen permitidos acceder a dicho componente. Se importa y se llama como una funcion
// en las rutas correspondientes ;)
export default function Authorization(WrappedComponent, authorized) {
  return class WithAuthorization extends React.Component {
    render() {
      if (authorized) {
        return <WrappedComponent {...this.props} />
      } else {
        return (
          <div className="main-content" style={{textAlign: 'center'}}>
            <h1>Acceso Denegado!</h1>
            <h3>No tiene permisos para acceder a esta página</h3>
            <p>Si cree que esto es un error contáctese con el Administrador del Sistema</p>
          </div>
        )
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/routes/Authorization.jsx